/**
 * When the voice is asked to speak (RFC 0307 3d).
 *
 * The person's own speech gets its reply from the provider's turn detection.
 * Everything else that could ask for a reply comes through here, and asks at
 * most once: a batch of tool results is one reply, after its last result; a
 * notice asks only when it is marked as needing the person; nothing asks
 * while the person is talking or a reply is already being spoken. Before
 * this, every notice and every tool result asked, and one line came back as
 * two or three replies.
 */

export class ReplyGate {
  private pending: string | null = null
  private speaking = false
  private responding = false
  private toolsOut = 0
  /** Replies asked for since the person last spoke. */
  askedSincePerson = 0

  constructor(private readonly respond: (reason: string) => void) {}

  personSaidSomething(): void {
    this.askedSincePerson = 0
  }
  speechStarted(): void {
    this.speaking = true
  }
  speechStopped(): void {
    this.speaking = false
    this.flush()
  }
  replyStarted(): void {
    this.responding = true
  }
  replyDone(): void {
    this.responding = false
    this.flush()
  }
  toolStarted(): void {
    this.toolsOut += 1
  }
  toolAnswered(): void {
    this.toolsOut = Math.max(0, this.toolsOut - 1)
    this.pending = 'tool results'
    this.flush()
  }
  /** A notice: asks for a reply only when it needs the person now. */
  noticed(speak: boolean): void {
    if (!speak) return
    this.pending = 'a notice that needs the person'
    this.flush()
  }

  private flush(): void {
    if (!this.pending || this.speaking || this.responding || this.toolsOut > 0)
      return
    const reason = this.pending
    this.pending = null
    // Claim the response before sending response.create. The server's
    // response.created event is asynchronous; another notice or tool result
    // can land in that gap and otherwise ask for a second response.
    this.responding = true
    this.askedSincePerson += 1
    this.respond(reason)
  }
}
